import Vue from 'vue'
import Router from 'vue-router'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Loading = () => import('@/views/Loading')

// Views - Pages
const Login = () => import('@/views/Login')

// Categories
const Categories = () => import('@/views/categories/Index')
const CreateCategory = () => import('@/views/categories/Create')
const EditCategory = () => import('@/views/categories/Edit')
const ShowCategory = () => import('@/views/categories/Show')
// SubCategories
const SubCategories = () => import('@/views/sub-categories/Index')
const CreateSubCategory = () => import('@/views/sub-categories/Create')
const EditSubCategory = () => import('@/views/sub-categories/Edit')
const ShowSubCategory = () => import('@/views/sub-categories/Show')
// Students
const Students = () => import('@/views/students/Index')
const CreateStudent = () => import('@/views/students/Create')
const EditStudent = () => import('@/views/students/Edit')
const ShowStudent = () => import('@/views/students/Show')

// Courses
const CreateCourse = () => import('@/views/courses/Create')
const EditCourse = () => import('@/views/courses/Edit')
const Courses = () => import('@/views/courses/Index')
const ShowCourse = () => import('@/views/courses/Show')
const CreateCoursetest = () => import('@/views/courses/test')

// Sections
const CreateSection = () => import('@/views/sections/Create')
const EditSection = () => import('@/views/sections/Edit')
const Sections = () => import('@/views/sections/Index')
const ShowSection = () => import('@/views/sections/Show')
// Lessons
const CreateLesson = () => import('@/views/lessons/Create')
const EditLesson = () => import('@/views/lessons/Edit')
const Lessons = () => import('@/views/lessons/Index')
const ShowLesson = () => import('@/views/lessons/Show')

// Instructors
const CreateInstructor = () => import('@/views/instructors/Create')
const EditInstructor = () => import('@/views/instructors/Edit')
const Instructors = () => import('@/views/instructors/Index')
const ShowInstructor = () => import('@/views/instructors/Show')

// Courses-Students
const Registrations = () => import('@/views/courses-students/Index')
const ShowRegistration = () => import('@/views/courses-students/Show')

const ShowProfile = () => import('@/views/site-profile/Edit')
// payments
const Payments = () => import('@/views/payments/Index')
const completedpayments = () => import('@/views/payments/completedpayments')
const ShowPayment = () => import('@/views/payments/Show')

const Certificates = () => import('@/views/certificates/Index')

Vue.use(Router)
Vue.use(VueTabs)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {

      path: '/',
      redirect: '/loading',
      name: 'الرئيسية',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'لوحة التحكم',
          component: Dashboard
        },

        // categories
        {
          path: 'categories',
          meta: {
            label: 'الأقسام'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'الأقسام الرئيسية',
              component: Categories
            },
            {
              name: 'تعديل القسم الرئيسي',
              path: ':id/edit',
              component: EditCategory
            },
            {
              path: 'create',
              name: 'إضافة قسم جديد',
              component: CreateCategory
            },
            {
              path: ':id/show',
              name: 'عرض القسم الرئيسي',
              component: ShowCategory
            }
          ]
        },
        // sub-categories
        {
          path: 'sub-categories',
          meta: {
            label: 'الأقسام'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'الأقسام الفرعية',
              component: SubCategories
            },
            {
              name: 'تعديل القسم الفرعي',
              path: ':id/edit',
              component: EditSubCategory
            },
            {
              path: 'create',
              name: 'إضافة قسم فرعي ',
              component: CreateSubCategory
            },
            {
              path: ':id/show',
              name: 'عرض القسم الفرعي',
              component: ShowSubCategory
            }
          ]
        },
        // Courses,
        {
          path: 'courses',
          meta: {
            label: 'الدورات '
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Courses
            },
            {
              path: 'create',
              name: 'إضافة دورة',
              component: CreateCourse
            },
            {
              name: 'تعديل الدورة',
              path: ':id/edit',
              component: EditCourse
            },
            {
              name: ' عرض الدورة  ',
              path: ':id/show',
              component: ShowCourse
            },
            {
              name: 'تست',
              path: 'test',
              component: CreateCoursetest

            }
          ]
        },
        // Sections,
        {
          path: 'sections',
          meta: {
            label: 'الوحدات '
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'الوحدات',
              component: Sections
            },
            {
              path: 'create',
              name: 'إضافة وحدة',
              component: CreateSection
            },
            {
              name: 'تعديل الوحدة',
              path: ':id/edit',
              component: EditSection
            },
            {
              name: ' عرض الوحدة  ',
              path: ':id/show',
              component: ShowSection
            }
          ]
        },
        // Lessons,
        {
          path: 'lessons',
          meta: {
            label: 'الدروس '
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'الدروس',
              component: Lessons
            },
            {
              path: 'create',
              name: 'إضافة درس',
              component: CreateLesson
            },
            {
              name: 'تعديل درس',
              path: ':id/edit',
              component: EditLesson
            },
            {
              name: ' عرض درس  ',
              path: ':id/show',
              component: ShowLesson
            }
          ]
        },
        // Instructors,
        {
          path: 'instructors',
          meta: {
            label: 'المدربين '
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Instructors
            },
            {
              path: 'create',
              name: 'إضافة مدرب',
              component: CreateInstructor
            },
            {
              name: 'تعديل مدرب',
              path: ':id/edit',
              component: EditInstructor
            },
            {
              name: ' عرض مدرب  ',
              path: ':id/show',
              component: ShowInstructor
            }
          ]
        },
        // Students
        {
          path: 'students',
          meta: {
            label: 'الطلاب'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Students
            },
            {
              path: 'create',
              name: 'إضافة طالب جديد',
              component: CreateStudent
            },
            {
              name: 'تعديل طالب',
              path: ':id/edit',
              component: EditStudent
            },
            {
              name: ' عرض الطالب  ',
              path: ':id/show',
              component: ShowStudent
            }
          ]
        },
        {
          path: 'referral-codes',
          meta: {
            label: 'أكواد  الدعوة'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: ' أكواد  الدعوة',
              component: () => import('@/views/referral-codes/Index')
            },
            {
              path: 'create',
              name: 'إضافة كود ',
              component: () => import('@/views/referral-codes/Create')
            },
            {
              path: ':id/edit',
              name: 'تعديل كود الدعوة',
              component: () => import('@/views/referral-codes/Edit')
            },
            {
              path: ':id/show',
              name: 'عرض كود الدعوة',
              component: () => import('@/views/referral-codes/Show')
            }
          ]
        },
        // Courses-Students
        {
          path: 'courses-students',
          meta: {
            label: 'تسجيلات الطلاب'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Registrations
            },
            {
              path: ':id/show',
              name: 'عرض الطلب',
              component: ShowRegistration
            }
          ]
        },
        // Payments
        {
          path: 'payments',
          meta: {
            label: 'المدفوعات'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Payments
            },
            {
              path: 'paid',
              name: 'الدفعيات المكتملة',
              component: completedpayments
            },
            {
              path: ':id/show',
              name: '  عرض مدفوعات الطالب',
              component: ShowPayment
            }
          ]
        },
        // Certificate
        {
          path: 'certificates',
          meta: {
            label: 'الشهادات'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: '',
              component: Certificates
            },
            {
              path: ':id/show',
              name: '  عرض مدفوعات الطالب',
              component: ShowPayment
            }
          ]
        },
        // Site-profile
        {
          path: 'site-profile',
          meta: {
            label: 'إعدادات الموقع'
          },
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'البيانات',
              component: ShowProfile
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      component: Login,
      name: 'Login'
    },
    {
      path: '/loading',
      component: Loading,
      name: 'Loading'
    }
  ]
}
